<template>
  <div class="modal" @mousedown="closeModal">
    <div class="card" style="max-width: 450px">
      <div class="card-header">
        <h1>Create New Form</h1>
        <p>Build a new online form using our drag-and-drop editor.</p>
      </div>
      <form class="card-body" @submit.prevent="attemptCreate">
        <div class="form-group">
          <label for="name" class="form-label">Form Name</label>
          <input id="name" type="text" name="name" ref="name" class="form-control" v-model="name"
            placeholder="Health History Form" autocomplete="off" data-lpignore="true" data-form-type="other" />
        </div>
      </form>
      <div class="card-footer">
        <button class="button primary" @click.prevent="attemptCreate">
          <img v-if="pending" src="/loading.svg" alt="Loading" class="loading" />
          <span v-else>Create Form</span>
        </button>
        <p class="error" v-if="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { createForm } from "@/api";

export default {
  name: "CreateFormModal",
  data() {
    return {
      name: "",
      error: "",
      pending: false,
    };
  },
  mounted() {
    setTimeout(() => {
      const nameRef = this.$refs.name;
      if (nameRef) nameRef.focus();
    }, 500);
  },
  methods: {
    async attemptCreate() {
      this.error = "";
      if (!this.name) {
        this.error = "Please provide a form name";
        return;
      }

      try {
        this.pending = true;
        const newForm = await createForm(this.name);
        this.$router.push(`/html-editor/${newForm.id}`);
      } catch (err) {
        console.error("Failed to create new form", err);
        this.error = err.message;
      } finally {
        this.pending = false;
      }
    },
    closeModal(event) {
      if (event.target.className != "modal") {
        return;
      }
      this.$emit("closeModal");
    },
  },
  emits: ["closeModal"],
};
</script>